"use client";

import {
  mobileHeroAspectRatio,
  paddingBottomMobile,
  util,
} from "@/common/theme";
import NineGLImageElement from "@/components/gl/NineGLImage/NineGLImageElement";
import styled from "styled-components";

import BorderedIcon from "@/components/BorderedIcon";
import { VIDEO_PLAYER_PLAY } from "@/components/VideoPlayer";
import emitter from "@/mono/lib/emitter";
import { useIsClient } from "@/mono/lib/hooks/useIsClient";
import { mediaMobile } from "@/mono/lib/responsive";
import { useGlobalStore } from "@/mono/store/global";
import SplitText from "mono/components/SplitText";

export function HomeShowReel() {
  const isClient = useIsClient();
  const isMobileLayout = useGlobalStore((s) => s.isMobileLayout);

  const videoSrc = isMobileLayout
    ? "/video/showreel_mobile.mp4"
    : "/video/showreel.mp4";

  const onScrollParams = {
    delay: 0.5,
  };

  if (!isClient) return null;

  return (
    <Wrapper>
      <div className="home__reel">
        <NineGLImageElement
          className="home__reel__gl"
          isVideo
          src={videoSrc}
          animateOnScroll
          useHover={false}
          darken={0.5}
        />

        <div className="home__reel__overlay">
          <SplitText
            animateOnScroll={true}
            onScrollParams={onScrollParams}
            tag="h3"
          >
            Watch our
          </SplitText>
          <SplitText
            animateOnScroll={true}
            onScrollParams={onScrollParams}
            tag="h3"
            className="home__reel__text-bottom"
          >
            showreel
          </SplitText>
          <BorderedIcon
            dontTriggerPageTransition
            icon="chevronRight"
            onScrollParams={onScrollParams}
            onClick={() =>
              emitter.emit(VIDEO_PLAYER_PLAY, { src: videoSrc.replace("/", "") })
            }
          />
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  ${util.inner};

  display: flex;
  justify-content: center;

  * {
    cursor: pointer;
  }

  .home__reel {
    position: relative;
    width: 2000rem;
    aspect-ratio: 16/9;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column nowrap;

    .home__reel__overlay {
      position: absolute;
      inset: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-flow: column nowrap;
      z-index: 2;
      pointer-events: none;

      > * {
        pointer-events: auto;
      }
    }

    h3 {
      position: relative;
      z-index: 1;
      color: ${({ theme }) => theme.colors.iron};
      font-weight: 100;
    }

    .home__reel__gl {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }

    .icon-chevronRight {
      position: relative;
      z-index: 1;
      border-color: ${({ theme }) => theme.colors.iron};
    }
    svg {
      position: relative;
      z-index: 1;
      path {
        stroke: ${({ theme }) => theme.colors.iron};
        fill: ${({ theme }) => theme.colors.iron};
      }
    }

    .icon-background {
      background: ${({ theme }) => theme.colors.iron};
    }

    .icon-duplicate {
      path {
        stroke: ${({ theme }) => theme.colors.outerSpace} !important;
        fill: ${({ theme }) => theme.colors.outerSpace} !important;
      }
    }

    .home__reel__text-bottom {
      display: block;
      font-weight: 500;
      margin-bottom: 50rem;
    }
  }

  ${mediaMobile(`
      .home__reel {
        aspect-ratio: ${mobileHeroAspectRatio};
      }

      margin-bottom: ${paddingBottomMobile};
    `)}
`;
